export var BetStatus;
(function (BetStatus) {
    BetStatus[BetStatus["UNSETTLE"] = 0] = "UNSETTLE";
    BetStatus[BetStatus["SETTLE"] = 1] = "SETTLE";
})(BetStatus || (BetStatus = {}));
//# sourceMappingURL=BetStatus.js.map